// extracted by mini-css-extract-plugin
export default {"menuWrapper":"TabsContainer_menuWrapper__34ZKv"};